import {
  GiftCardTransactionType,
  OrderTransactionType,
  ScanToPayTranasctionType,
} from '../transactions.types';

type TransactionFixtureType = {
  order: OrderTransactionType;
  giftCard: GiftCardTransactionType;
  scanToPay: ScanToPayTranasctionType;
};

export const transaction: TransactionFixtureType = {
  order: {
    transactionId: 'ch_3M4gXbKdZ3YHmMQb1r777RNY',
    clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
    locationId: '5d69f9ee-5628-4b64-98f7-685e425d63a1',
    createdDate: '2022-11-16T08:00:16Z',
    items: [
      {
        orderItemId: '63749845e4b05ec362e3af51',
        itemId: '63325578e4b02d805c242834',
        itemName: 'Import - APPLE PIE',
        displayInfoTitle: 'Apple Pie',
        group: {
          groupId: '63325804e4b02d805c242835',
          groupType: 'CATALOG_GROUP',
          groupName: 'Desserts',
          privateAttributes: {},
        },
        catalogId: '633258afe4b02d805c242836',
        unitPrice: 2490,
        quantity: 1,
        additionalAttributes: { recommendation_status: 'PRE' },
        externalId: 'externalId',
        itemInstructions: '',
        displayInfo: {
          langCode: 'EN',
          title: 'Apple Pie',
          shortDescription:
            'Flakey crust on the outside, cinnamon apple filling on the inside, \u0026  heavily dusted with powdered sugar.',
          smallImage: [],
          mediumImage: [],
        },
        privateAttributes: { DISPLAY_RANK: '1' },
        isTaxable: true,
        originalIsTaxable: true,
        taxes: [],
        itemTotal: {
          preDiscountSubtotal: 2490,
          appliedDiscount: 0,
          subtotal: 2490,
          total: 2490,
        },
        displayRank: 1,
        outOfOrder: false,
      },
    ],
    userId: 'GUEST',
    orderTotal: {
      preDiscountSubtotal: 2490,
      taxSummary: {
        totalTaxes: 90,
        taxes: [
          {
            displayTaxAmountApplied: '0.09',
            taxAmountApplied: 90,
            taxDescription: 'State Tax',
            taxId: null,
          },
        ],
      },
      chargeSummary: {
        taxableCharges: 0,
        nonTaxableCharges: 1500,
        bigTaxableCharges: 0,
        bigNonTaxableCharges: 0,
        charges: [
          {
            chargeApplied: 1500,
            chargeDescription: 'Packing Charge',
            chargeId: '31f371ee-75ff-4326-8464-b220f1cd92a1',
            chargeName: null,
            delivery: true,
            displayChargeApplied: '1.50',
            gratuity: false,
            taxable: false,
          },
        ],
      },
      totalDiscountApplied: 0,
      subtotal: 2490,
      gratuity: 750,
      total: 3240,
    },
    chargeAmount: 3240,
    applicationFee: 150,
    orderId: '63749841e4b05ec362e3af50',
    currency: 'usd',
    paymentMethod: {
      paymentMethodId: 'pm_1M4gXOKdZ3YHmMQbR3hgk2E9',
      type: 'card',
      cardBrand: 'visa',
      lastFour: '1111',
      expirationMonth: 11,
      expirationYear: 2023,
      billingZip: '01234',
    },
    paymentIntentId: 'pi_3M4gXbKdZ3YHmMQb1P5dmsSf',
    refunds: [],
    stripeReceiptUrl:
      'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xSjNQTGFLZFozWUhtTVFiKJGx0psGMgaPwF9Kz1g6LBa3_BuSgrq9WseLc84xwRy8MSl7k4HHA80nCfYVSXhr2nrabOWtWE8ba-50',
    stripeAccountId: 'acct_1LmKQpQKILVC4wUm',
    status: 'SUCCEEDED',
    type: 'ORDER',
    paymentFailures: [],
    events: [
      {
        eventId: 'evt_3MA4fhKdZ3YHmMQb1kZEoxcd',
        type: 'PAYMENT_SUCCESS',
        createdDate: '2022-12-01T04:46:55.157Z',
      },
      {
        type: 'REFUND_SUCCESS',
        createdDate: '2022-12-01T07:35:40.471Z',
        refundDetails: {
          refundId: 're_3MA4fhKdZ3YHmMQb1PjTmy4G',
          refundReason: 'Refund reason',
          refundAmount: 1000,
          createdDate: '2022-12-01T07:35:39Z',
        },
      },
      {
        type: 'REFUND_SUCCESS',
        createdDate: '2022-12-01T13:15:07.424Z',
        refundDetails: {
          refundId: 're_3MA4fhKdZ3YHmMQb1PJF8wRh',
          refundReason: 'soemthing',
          refundAmount: 2240,
          createdDate: '2022-12-01T13:15:06Z',
        },
      },
    ],
    customer: {
      firstName: 'Test Order',
      lastName: 'Dont Prepare',
      email: 'marjan.m@incentivio.com',
    },
    giftCardId: '5225805786649509',
  },
  giftCard: {
    transactionId: 'ch_3MFTs7KdZ3YHmMQb05u6ggTT',
    clientId: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
    locationId: 'POOL_ACCOUNT',
    createdDate: '2022-12-16T02:42:03Z',
    customer: {
      firstName: 'Incentivio',
      lastName: 'Order',
      email: 'stripeuser@incentivio.com',
    },
    giftCardId: '5225805786649509',
    chargeAmount: 100000,
    applicationFee: 200,
    giftcardTxId: '639bdafbbca9542bf4bef2f3',
    currency: 'usd',
    paymentMethod: {
      paymentMethodId: 'pm_1MFC6lKdZ3YHmMQbd3IuMfAm',
      type: 'card',
      cardBrand: 'jcb',
      lastFour: '0505',
      expirationMonth: 12,
      expirationYear: 2058,
    },
    paymentIntentId: 'pi_3MFTs7KdZ3YHmMQb071ibIHS',
    stripeReceiptUrl:
      'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xSjNQTGFLZFozWUhtTVFiKPy175wGMgbyIKM5u7Y6LBbclhg2S1aimHD4ID9v5oO03pujtbtJMrOSQiJUbXYAbXluc2vPf39aMudT',
    stripeAccountId: 'acct_1LmjRwQNYOQEMwoD',
    status: 'SUCCEEDED',
    type: 'GIFTCARD_PURCHASE',
    refunds: [
      {
        refundId: 're_3O7FwqKdZ3YHmMQb1uwdUjTQ',
        refundAmount: 18990,
        createdDate: '2023-10-31T14:25:34.905Z',
      },
    ],
    paymentFailures: [],
    events: [
      {
        eventId: 'evt_3MFTs7KdZ3YHmMQb0QF4tjpI',
        type: 'PAYMENT_SUCCESS',
        createdDate: '2022-12-16T02:42:04.548Z',
      },
    ],
  },
  scanToPay: {
    transactionId: 'ch_3O7FwqKdZ3YHmMQb1zpi7BAN',
    clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    locationId: '952e1839-75f2-4d4b-9949-3760579583b8',
    createdDate: '2023-10-31T11:17:28Z',
    userId: '11f42a30-58db-4822-be7e-572b3309ea39',
    chargeAmount: 18990,
    applicationFee: 100,
    scanToPayTxId: '7025dfe0-a2df-40ca-868b-c1040aa14b1f',
    currency: 'usd',
    paymentMethod: {
      paymentMethodId: 'card_1O7FwqKdZ3YHmMQbX6Qw9IgJ',
      type: 'card',
      cardBrand: 'visa',
      lastFour: '1111',
      expirationMonth: 9,
      expirationYear: 2030,
    },
    statementDescriptor: 'PALMLANEDEV',
    stripeReceiptUrl:
      'https://pay.stripe.com/receipts/payment/CAcaFwoVYWNjdF8xSjNQTGFLZFozWUhtTVFiKMnEg6oGMgai0VjO9II6LBZrD36PDfjHOdR8-SkDa6Y6t73owrryXxVxi0irprJraS6jQ_sNE5bDOCxb',
    stripeAccountId: 'acct_1NckehQKpc45sl2h',
    status: 'REFUNDED',
    type: 'SCAN_TO_PAY',
    refunds: [
      {
        refundId: 're_3O7FwqKdZ3YHmMQb1uwdUjTQ',
        refundAmount: 18990,
        createdDate: '2023-10-31T14:25:34.905Z',
      },
    ],
    paymentFailures: [],
    events: [
      {
        eventId: 'evt_3O7FwqKdZ3YHmMQb1B23JuQd',
        type: 'PAYMENT_SUCCESS',
        createdDate: '2023-10-31T11:17:29.743Z',
      },
      {
        eventId: 'evt_3O7FwqKdZ3YHmMQb1stB4Fxk',
        type: 'REFUND_SUCCESS',
        createdDate: '2023-10-31T14:25:34.905Z',
        refundDetails: {
          refundId: 're_3O7FwqKdZ3YHmMQb1uwdUjTQ',
          refundAmount: 18990,
          createdDate: '2023-10-31T14:25:34.905Z',
        },
      },
    ],
  },
};
